import React from "react";
import Button from "./Button.tsx";

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Unhandled UI error:", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen px-6 py-12 flex items-center justify-center">
        <div className="max-w-xl w-full bg-white rounded-lg p-10 border border-border font-body text-ink text-center">
          <h1 className="text-3xl font-bold font-display mb-4">Something went wrong</h1>
          <p className="text-gray-500 mb-8">An unexpected error occurred. Reload the page or return to the home page.</p>
          <div className="flex gap-4 justify-center">
            <Button onClick={() => window.location.reload()}>Reload</Button>
            <Button variant="secondary" onClick={() => window.location.assign("/")}>
              Home
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
